module.exports = __webpack_public_path__ + "media/images/cc_logos/american_express-55d0c788b490f245b154010306001c64.png";